const UserIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
            d="M8.00002 8.66667C9.84097 8.66667 11.3334 7.17428 11.3334 5.33333C11.3334 3.49238 9.84097 2 8.00002 2C6.15907 2 4.66669 3.49238 4.66669 5.33333C4.66669 7.17428 6.15907 8.66667 8.00002 8.66667ZM8.00002 8.66667C9.41451 8.66667 10.7711 9.22857 11.7713 10.2288C12.7715 11.229 13.3334 12.5855 13.3334 14M8.00002 8.66667C6.58553 8.66667 5.22898 9.22857 4.22878 10.2288C3.22859 11.229 2.66669 12.5855 2.66669 14"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default UserIcon;
